import sha256 from 'crypto-js/sha256';

export const getSha256Hashed = (str) => sha256(str);
